module.exports = __webpack_public_path__ + "static/img/AmkjLOGO.c3dd010.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AmkjLOGO.png
// module id = Mgt4
// module chunks = 1